import { toast } from 'react-toastify';
import { t } from 'i18next'
import { Trans } from 'react-i18next';
import timeFormat from '../../../../hooks/timeFormat';

export default function buyResponse(response:any, openDonateMenu:Function) {
    if (response?.status===200)
        return toast.success(<Trans
            i18nKey='main.products.buy.success'
            components={[<span className='highlight_notify_success' />]}
        />)

    if (['PRODUCTS_BUY_INSUFFICIENT_FUNDS'].includes(response?.data?.error)) {
        const remainAmount = response?.data?.remains;
        return toast.error(<div className='flex-column' onClick={() => openDonateMenu(remainAmount)}>
            {t(`main.products.buy.status.${response?.data?.error}`)}
            <span className='fw-bold'>{new Intl.NumberFormat('ru-RU').format(Math.floor(remainAmount))} ₽</span>
        </div>)
    }

    if (['PRODUCTS_BUY_UNAUTHORIZED', 'PRODUCTS_BUY_PRODUCT_EMPTY_PLAN_ID', 'REFUND_ERROR'].includes(response?.data?.error))
        return toast.error(t(`main.products.buy.status.${response?.data?.error}`))

    if (['PRODUCTS_BUY_COOLDOWN'].includes(response?.data?.error))
        return toast.error(
            <Trans
                i18nKey={`main.products.buy.status.${response?.data?.error}`}
                values={{
                    time: timeFormat(response?.data?.remains?.cooldown),
                }}
                components={[<span className='fw-bold' />]}
            />
        )

    if (response?.status===503)
        return toast.error(t(`popup.maintenance`))

    else return toast.error(t('popup.connectionLost'))
}